"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const executeTransition_1 = __importDefault(require("./executeTransition"));
const buildPreviewerNavigation = (routing) => {
    const replace = ({ pageId, transition, params }) => {
        if (!pageId || routing.getCurrentPageId() === pageId) {
            return;
        }
        routing.push({
            pageId,
            transition,
            params,
        });
        if (transition === null || transition === void 0 ? void 0 : transition.type) {
            routing.updateTransitionCurrentPage(transition);
            (0, executeTransition_1.default)(transition === null || transition === void 0 ? void 0 : transition.speed)
                .then(() => routing.cleanPreviousAfterReplace());
            return;
        }
        routing.cleanPreviousAfterReplace();
    };
    const push = ({ pageId, transition, params }) => {
        if (!pageId || routing.getCurrentPageId() === pageId) {
            return;
        }
        routing.push({
            pageId,
            transition,
            params,
        });
    };
    const goBack = (transition) => {
        if (transition === null || transition === void 0 ? void 0 : transition.type) {
            routing.updateTransitionCurrentPage(transition);
            (0, executeTransition_1.default)(transition === null || transition === void 0 ? void 0 : transition.speed).then(() => routing.goBack());
            return;
        }
        routing.goBack();
    };
    return {
        replace, push, goBack,
    };
};
exports.default = buildPreviewerNavigation;
